import { fork, call, put, all, takeEvery } from "redux-saga/effects";
import * as actionNameTypes from "./actionType";
import asyncInterface from "../../asyncInterface";
import { getAccountData } from '../../utils/sessionUtil';

export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.exchangeActivity.fetchAccountData(fetchPayload);
}

export function* fetchMessageWorker(data) {
  yield put({ type: actionNameTypes.messageDataLoadingType });
  try {
    try {
      var accountDetailForMessage = yield call(fetchAccountData, data.payload.additionalAccountDetails);
      yield put({
        type: actionNameTypes.additionalAccountDetailsType,
        payload: accountDetailForMessage.data
      });
      accountDetailForMessage = accountDetailForMessage.data;
      const userData = getAccountData();
      if(accountDetailForMessage !=null && accountDetailForMessage.allShareAllPoolGrantExist) {
        let allShareAllPoolGrantExist = { ...userData, ...{"allShareAllPoolGrantExist" : true }};
        sessionStorage.setItem("userData", JSON.stringify(allShareAllPoolGrantExist));
        }else if(accountDetailForMessage !=null && !accountDetailForMessage.allShareAllPoolGrantExist) {
          let allShareAllPoolGrantExist = { ...userData, ...{"allShareAllPoolGrantExist" : false }};
          sessionStorage.setItem("userData", JSON.stringify(allShareAllPoolGrantExist));
          }
    } catch (error) {
    }
    const response = yield call(fetchAccountData, data.payload.messagingData);
    const filteredMessages = response.data.filter(item => {
      if (accountDetailForMessage.primaryAccountContact) {
        if ((accountDetailForMessage.segmentation ? (item.field_account_segment.toLowerCase() === accountDetailForMessage.segmentation.toLowerCase() || !item.field_account_segment) : true)
          && (accountDetailForMessage.accountAllRoles ? ((accountDetailForMessage.accountAllRoles.toLowerCase().includes(item.field_account_role.toLowerCase())) || !item.field_account_role || (item.field_account_role === "Primary Account Contact")) : true)
          && (accountDetailForMessage.vangaurdClient ? (item.field_vanguard_client.toLowerCase() === accountDetailForMessage.vangaurdClient.toLowerCase() || !item.field_vanguard_client) : true)
        ) {
          return item;
        }
      } else {
        if ((accountDetailForMessage.segmentation ? (item.field_account_segment.toLowerCase() === accountDetailForMessage.segmentation.toLowerCase() || !item.field_account_segment) : true)
          && (accountDetailForMessage.accountAllRoles ? ((accountDetailForMessage.accountAllRoles.toLowerCase().includes(item.field_account_role.toLowerCase())) || !item.field_account_role) : true)
          && (accountDetailForMessage.vangaurdClient ? (item.field_vanguard_client.toLowerCase() === accountDetailForMessage.vangaurdClient.toLowerCase() || !item.field_vanguard_client) : true)

        ) {
          return item;
        }
      }

    });

    yield put({
      type: actionNameTypes.messagingDataSuccessType,
      payload: filteredMessages
    });
  } catch (error) {
    yield put({
      type: actionNameTypes.messagingDataFailureType,
      error
    });
  }
}

export function* fetchAllMessageWorker(data) {
  yield put({ type: actionNameTypes.messagingAllDataLoadingType });
  try {
    const response = yield call(fetchAccountData, data.payload);
    yield put({
      type: actionNameTypes.messagingAllDataSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionNameTypes.messagingAllDataFailureType,
      error
    });
  }
}


export function* fetchMessageWatcher() {
  yield takeEvery(actionNameTypes.fetchMessageType, fetchMessageWorker);
}
export function* fetchAllMessageWatcher() {
  yield takeEvery(actionNameTypes.fetchAllMessageType, fetchAllMessageWorker);
}

export default function* MessagingSaga() {
  yield all([fork(fetchMessageWatcher),
  fork(fetchAllMessageWatcher)])
}
